module.exports = __webpack_public_path__ + "img/5a_Users.2087c48e.png";